import { initializeForm } from 'common/modules/managePassword/actions';

import toggleModalPassword from './toggleModalPassword';

export default (id) => (dispatch) => {
    dispatch(initializeForm({ id }));
    dispatch(toggleModalPassword(true));
};
